import {
  Truck, MapPin, Zap, Package, ClipboardList, Edit, Move, FileText, History,
  ScanLine, Printer, ShoppingBag, Layers, ShoppingCart, Combine, PenTool, Search
} from 'lucide-react';

export interface OperatorModule {
  id: string;
  moduleId: string;
  icon: any;
  iconName: string;
  color: string;
  nameKey: string;
  nameFallback: string;
  shortNameKey: string;
  shortNameFallback: string;
  descriptionKey: string;
  descriptionFallback: string;
  requiresAdvancedWarehouse?: boolean;
}

export const OPERATOR_MODULES: OperatorModule[] = [
  {
    id: 'receipt',
    moduleId: 'receipt',
    icon: Truck,
    iconName: 'Truck',
    color: 'purple',
    nameKey: 'warehouse.modules.receipt.title',
    nameFallback: 'Varemottak',
    shortNameKey: 'warehouse.modules.receipt.shortName',
    shortNameFallback: 'Mottak',
    descriptionKey: 'warehouse.modules.receipt.description',
    descriptionFallback: 'Motta leveranser'
  },
  {
    id: 'put-away',
    moduleId: 'put-away',
    icon: MapPin,
    iconName: 'MapPin',
    color: 'green',
    nameKey: 'warehouse.modules.putaway.title',
    nameFallback: 'Plassering',
    shortNameKey: 'warehouse.modules.putaway.shortName',
    shortNameFallback: 'Plass.',
    descriptionKey: 'warehouse.modules.putaway.description',
    descriptionFallback: 'Plasser varer'
  },
  {
    id: 'modern-picking',
    moduleId: 'modern-picking',
    icon: Zap,
    iconName: 'Zap',
    color: 'yellow',
    nameKey: 'warehouse.modules.picking.title',
    nameFallback: 'Plukk',
    shortNameKey: 'warehouse.modules.picking.shortName',
    shortNameFallback: 'Plukk',
    descriptionKey: 'warehouse.modules.picking.description',
    descriptionFallback: 'Effektiv plukking'
  },
  {
    id: 'packing',
    moduleId: 'packing',
    icon: Package,
    iconName: 'Package',
    color: 'orange',
    nameKey: 'warehouse.modules.packing.title',
    nameFallback: 'Pakking',
    shortNameKey: 'warehouse.modules.packing.shortName',
    shortNameFallback: 'Pakk',
    descriptionKey: 'warehouse.modules.packing.description',
    descriptionFallback: 'Pakk og klargjør forsendelser'
  },
  {
    id: 'inventory',
    moduleId: 'inventory',
    icon: ClipboardList,
    iconName: 'ClipboardList',
    color: 'indigo',
    nameKey: 'warehouse.modules.inventory.title',
    nameFallback: 'Lagertelling',
    shortNameKey: 'warehouse.modules.inventory.shortName',
    shortNameFallback: 'Telling',
    descriptionKey: 'warehouse.modules.inventory.description',
    descriptionFallback: 'Tell lagerbeholdning'
  },
  {
    id: 'correction',
    moduleId: 'correction',
    icon: Edit,
    iconName: 'Edit',
    color: 'red',
    nameKey: 'warehouse.modules.inventoryCorrection.title',
    nameFallback: 'Korreksjon',
    shortNameKey: 'warehouse.modules.inventoryCorrection.shortName',
    shortNameFallback: 'Korr.',
    descriptionKey: 'warehouse.modules.inventoryCorrection.description',
    descriptionFallback: 'Korriger feil'
  },
  {
    id: 'movement',
    moduleId: 'movement',
    icon: Move,
    iconName: 'Move',
    color: 'cyan',
    nameKey: 'warehouse.modules.warehouseTransfer.title',
    nameFallback: 'Lager-/Lokasjonsflytt',
    shortNameKey: 'warehouse.modules.warehouseTransfer.shortName',
    shortNameFallback: 'Flytt',
    descriptionKey: 'warehouse.modules.warehouseTransfer.description',
    descriptionFallback: 'Flytt varer'
  },
  {
    id: 'item-admin',
    moduleId: 'item-admin',
    icon: FileText,
    iconName: 'FileText',
    color: 'teal',
    nameKey: 'warehouse.modules.itemAdmin.title',
    nameFallback: 'Vareadministrasjon',
    shortNameKey: 'warehouse.modules.itemAdmin.shortName',
    shortNameFallback: 'Vare',
    descriptionKey: 'warehouse.modules.itemAdmin.description',
    descriptionFallback: 'Administrer varer'
  },
  {
    // Varekort v2 (Plan-Varekort-v2.md) — MIDLERTIDIG kort ved siden av item-admin mens det testes.
    // Ved lansering: pek item-admin-kortet til item-card og fjern denne oppføringen.
    id: 'item-card',
    moduleId: 'item-card',
    icon: Search,
    iconName: 'Search',
    color: 'blue',
    nameKey: 'warehouse.modules.itemCard.menuTitle',
    nameFallback: 'Varekort (ny)',
    shortNameKey: 'warehouse.modules.itemCard.shortName',
    shortNameFallback: 'Varekort',
    descriptionKey: 'warehouse.modules.itemCard.description',
    descriptionFallback: 'Skann eller søk opp en vare'
  },
  {
    id: 'field-registration',
    moduleId: 'field-registration',
    icon: ScanLine,
    iconName: 'ScanLine',
    color: 'emerald',
    nameKey: 'warehouse.modules.fieldRegistration.title',
    nameFallback: 'Lokasjonsvedlikehold',
    shortNameKey: 'warehouse.modules.fieldRegistration.shortName',
    shortNameFallback: 'Lok.vedl.',
    descriptionKey: 'warehouse.modules.fieldRegistration.description',
    descriptionFallback: 'Endre lokasjonsoppsett'
  },
  {
    id: 'capacity-registration',
    moduleId: 'capacity-registration',
    icon: Layers,
    iconName: 'Layers',
    color: 'teal',
    nameKey: 'warehouse.modules.capacityRegistration.title',
    nameFallback: 'Kapasitetsregistrering',
    shortNameKey: 'warehouse.modules.capacityRegistration.shortName',
    shortNameFallback: 'Kapasitet',
    descriptionKey: 'warehouse.modules.capacityRegistration.description',
    descriptionFallback: 'Oppdater lokasjonskapasitet for varer',
    requiresAdvancedWarehouse: true
  },
  {
    id: 'consolidation',
    moduleId: 'consolidation',
    icon: Combine,
    iconName: 'Combine',
    color: 'lime',
    nameKey: 'warehouse.modules.consolidation.title',
    nameFallback: 'Konsolidering',
    shortNameKey: 'warehouse.modules.consolidation.shortName',
    shortNameFallback: 'Konsolider',
    descriptionKey: 'warehouse.modules.consolidation.description',
    descriptionFallback: 'Samle spredt beholdning og frigjør lokasjoner',
    requiresAdvancedWarehouse: true
  },
  {
    id: 'history',
    moduleId: 'history',
    icon: History,
    iconName: 'History',
    color: 'gray',
    nameKey: 'warehouse.modules.history.title',
    nameFallback: 'Historikk',
    shortNameKey: 'warehouse.modules.history.shortName',
    shortNameFallback: 'Hist.',
    descriptionKey: 'warehouse.modules.history.description',
    descriptionFallback: 'Se avsluttede plukklister'
  },
  {
    id: 'print-history',
    moduleId: 'print-history',
    icon: Printer,
    iconName: 'Printer',
    color: 'slate',
    nameKey: 'warehouse.modules.printHistory.title',
    nameFallback: 'Utskriftshistorikk',
    shortNameKey: 'warehouse.modules.printHistory.shortName',
    shortNameFallback: 'Utskrift',
    descriptionKey: 'warehouse.modules.printHistory.description',
    descriptionFallback: 'Se utskriftshistorikk og skriv ut på nytt'
  },
  {
    id: 'direct-customer-order',
    moduleId: 'direct-customer-order',
    icon: ShoppingBag,
    iconName: 'ShoppingBag',
    color: 'blue',
    nameKey: 'warehouse.modules.directOrder.title',
    nameFallback: 'Direkteordre',
    shortNameKey: 'warehouse.modules.directOrder.shortName',
    shortNameFallback: 'Dir.ordre',
    descriptionKey: 'warehouse.modules.directOrder.description',
    descriptionFallback: 'Opprett kundeordre direkte'
  },
  {
    id: 'bestillingssystem',
    moduleId: 'bestillingssystem',
    icon: ShoppingCart,
    iconName: 'ShoppingCart',
    color: 'blue',
    nameKey: 'warehouse.modules.bestillingssystem.title',
    nameFallback: 'Bestillingssystem',
    shortNameKey: 'warehouse.modules.bestillingssystem.shortName',
    shortNameFallback: 'Best.',
    descriptionKey: 'warehouse.modules.bestillingssystem.description',
    descriptionFallback: 'Bestill varer fra avdeling til sentrallager'
  },
  {
    // Utlevering (Teamwork 36334240): kunde/sjåfør henter varer og signerer —
    // samme signaturmekanisme som plukkbildet, oppslag på ordrenivå.
    id: 'delivery-handover',
    moduleId: 'delivery-handover',
    icon: PenTool,
    iconName: 'PenTool',
    color: 'teal',
    nameKey: 'warehouse.modules.deliveryHandover.title',
    nameFallback: 'Utlevering',
    shortNameKey: 'warehouse.modules.deliveryHandover.shortName',
    shortNameFallback: 'Utlev.',
    descriptionKey: 'warehouse.modules.deliveryHandover.description',
    descriptionFallback: 'Kunde henter varer og signerer'
  }
];
